"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _createReactClass = _interopRequireDefault(require("create-react-class"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _classnames = _interopRequireDefault(require("classnames"));

var _devLogger = _interopRequireDefault(require("react-utils/devLogger"));

var _reactDom = require("react-dom");

var _UIHelpIcon = _interopRequireDefault(require("../icon/UIHelpIcon"));

var _UIFormLabel = _interopRequireDefault(require("./UIFormLabel"));

var _UICheckbox = _interopRequireDefault(require("../input/UICheckbox"));

var _UITooltip = _interopRequireDefault(require("../tooltip/UITooltip"));

var _PlacementConstants = require("../tooltip/PlacementConstants");

var _elements = require("../elements");

var _validateUIFormControlValidationMessage = _interopRequireDefault(require("./utils/validateUIFormControlValidationMessage"));

var _decorators = require("../utils/propTypes/decorators");

var _renderProp = require("../utils/propTypes/renderProp");

var _underscore = require("../utils/underscore");

var _FieldsetContext = require("../context/FieldsetContext");

var _HoverProvider = _interopRequireDefault(require("../providers/HoverProvider"));

var _sizes = require("HubStyleTokens/sizes");

var _deprecated = _interopRequireDefault(require("../utils/propTypes/deprecated"));

var InlineFormLabel = (0, _styledComponents.default)(_UIFormLabel.default).withConfig({
  displayName: "UIFormControl__InlineFormLabel",
  componentId: "ham3pi-0"
})(["&&{display:inline;}"]);

var LabelWrapper = _styledComponents.default.div.withConfig({
  displayName: "UIFormControl__LabelWrapper",
  componentId: "ham3pi-1"
})(["&&{padding-bottom:", ";padding-top:", ";}"], function (_ref) {
  var hasLabel = _ref.hasLabel,
      hasHelp = _ref.hasHelp;
  return (hasLabel || hasHelp) && _sizes.LABEL_DEFAULT_PADDING_BOTTOM;
}, function (_ref2) {
  var hasLabel = _ref2.hasLabel,
      hasHelp = _ref2.hasHelp;
  return hasHelp && !hasLabel && _sizes.LABEL_DEFAULT_PADDING_TOP;
});

var sizeClasses = {
  small: 'private-form__control--small',
  medium: ''
};

var getClassName = function getClassName(className, error, label, _size, verticalSeparation) {
  return (0, _classnames.default)('private-form__set', className, sizeClasses[_size], !!error && 'private-form__set--error', !label && 'private-form__set--no-label', {
    'flush': 'private-form__set--flush',
    'separated': 'private-form__set--separated'
  }[verticalSeparation]);
};

var getClosestDescendantId = function getClosestDescendantId(child) {
  var element = child;
  var id = element.props.id;

  while (id == null) {
    try {
      element = _react.Children.only(element.props.children);
    } catch (e) {
      break;
    }

    id = element.props.id;
  }

  return id;
};

var getDerivedId = function getDerivedId(inputProps, id) {
  var IDs = Object.keys(inputProps).filter(function (prop) {
    return inputProps[prop];
  }).map(function (prop) {
    if (!inputProps[prop]) return '';
    return id + "-" + prop;
  });
  if (IDs.length > 0) return IDs.join(' ');
  return undefined;
};

var getHtmlFor = function getHtmlFor(propValue, children) {
  var firstChild = _react.Children.only(children);

  if (propValue) {
    return propValue;
  }

  if (firstChild) {
    return getClosestDescendantId(firstChild) || name;
  }

  return null;
};

var renderInput = function renderInput(ariaLabel, ariaLabelledBy, children, description, error, help, required, validationMessage, disabledFieldset, fallbackId) {
  var child = _react.Children.only(children);

  var origRequired = child.props.required; // if the child input doesn't declare `required`, pass it down

  var newRequired = required === true ? true : origRequired;
  var newError = error === true ? 'true' : undefined;
  var cloneProps = {
    'aria-label': ariaLabel,
    'aria-labelledby': ariaLabelledBy,
    required: newRequired,
    'aria-invalid': newError,
    'aria-required': newRequired
  }; // only add id prop if it doesn't have it already

  var descendantId = getClosestDescendantId(child);

  if (!descendantId) {
    cloneProps.id = fallbackId;
  } // only add error prop if there is an error, to avoid potential "Unknown prop" warnings


  if (error) {
    cloneProps.error = !!error;
  } // disable the input if we're within a disabled fieldset (#3356)


  if (disabledFieldset) {
    cloneProps.disabled = true;
  } // aggregate IDs to pass into aria-describedby


  var newDescribedBy = getDerivedId({
    validationMessage: validationMessage,
    help: help,
    description: description
  }, cloneProps.id); // derive ID and spread back into cloneProps

  var describedCloneProps = {
    'aria-describedby': newDescribedBy
  };
  var mergedCloneProps = Object.assign({}, cloneProps, {}, describedCloneProps);
  return (0, _react.cloneElement)(child, mergedCloneProps);
};

var renderLabel = function renderLabel(children, label, labelClassName, error, htmlFor, labelId, required, tooltip, tooltipPlacement, tooltipProps, renderedInput, handleLabelClick, disabledFieldset, FormLabel, refCallback) {
  if (!label) return null;

  var _Children$only$props = _react.Children.only(children).props,
      childDisabled = _Children$only$props.disabled,
      childReadOnly = _Children$only$props.readOnly;

  var renderedLabel = _react.default.createElement(FormLabel, {
    className: (0, _classnames.default)(labelClassName, !!tooltip && 'private-form__label--with-tooltip'),
    error: !!error,
    htmlFor: getHtmlFor(htmlFor, renderedInput),
    id: labelId,
    onClick: handleLabelClick,
    readOnly: childDisabled || childReadOnly || disabledFieldset,
    required: required,
    ref: refCallback
  }, label);

  return tooltip ? _react.default.createElement(_UIHelpIcon.default, {
    className: "private-form__help-tooltip",
    title: tooltip,
    tooltipPlacement: tooltipPlacement,
    tooltipProps: tooltipProps
  }, renderedLabel) : renderedLabel;
};

var renderHelp = function renderHelp(help, helpClassName, renderedInputId) {
  if (!help) return null;
  return _react.default.createElement(_elements.Small, {
    className: (0, _classnames.default)('private-form__inlinehelp', helpClassName),
    id: getDerivedId({
      help: help
    }, renderedInputId),
    tabIndex: -1,
    use: "help"
  }, help);
};

var renderValidation = function renderValidation(error, validationMessage, inputId) {
  var validationClass = 'private-form__validation';

  if (validationMessage) {
    (0, _validateUIFormControlValidationMessage.default)({
      error: error,
      validationMessage: validationMessage
    });
    return _react.default.createElement(_elements.Small, {
      className: validationClass,
      id: getDerivedId({
        validationMessage: validationMessage
      }, inputId),
      tabIndex: -1,
      use: error ? 'error' : 'success'
    }, validationMessage);
  }

  return null;
};

var renderCounter = function renderCounter(characterCount) {
  return characterCount == null ? null : _react.default.createElement(_elements.Small, {
    className: "private-form__counter"
  }, characterCount);
};

var renderDescription = function renderDescription(description, inputId) {
  if (!description) return null;

  _devLogger.default.warn({
    message: "UIFormControl: the `description` prop has been deprecated. Please use the `help` prop instead.",
    key: "UIFormControl: description prop"
  });

  return _react.default.createElement(_elements.Small, {
    className: "private-form__description",
    id: getDerivedId({
      description: description
    }, inputId),
    tabIndex: -1,
    use: "help"
  }, description);
};
/**
 * Group a form field, label, notes, and errors/alerts together
 **/


var UIFormControl = (0, _createReactClass.default)({
  displayName: 'UIFormControl',
  propTypes: {
    /**
     * Instructional text to display with the field label
     **/
    'aria-label': _propTypes.default.string,

    /** List of IDs that label this input */
    'aria-labelledby': _propTypes.default.string,

    /**
     * Display character count metadata beneath the input
     */
    characterCount: _propTypes.default.node,

    /**
     * Pass the form input as a child. Label will be linked by provided ID, or
     * a random unique ID will be assigned to the input for linking.
     **/
    children: _propTypes.default.node.isRequired,

    /**
     * Detailed description of component. Similar to `help` but more in-depth
     **/
    description: (0, _deprecated.default)(_propTypes.default.oneOfType([_propTypes.default.node, _propTypes.default.bool])),

    /**
     * `true` indicates this field is in an error state
     **/
    error: _propTypes.default.bool,

    /**
     * Label render prop
     */
    FormLabel: (0, _renderProp.getPropType)(_UIFormLabel.default),

    /**
     * Message to be displayed at the bottom of the input
     *
     * By default the text is green
     * If `error` is set to `true` then the text is red
     **/
    validationMessage: _propTypes.default.node,

    /**
     * Instructional text to display with the field label
     **/
    help: _propTypes.default.node,

    /**
     * Class name for the <span> wrapper around the `text` prop
     **/
    helpClassName: _propTypes.default.string,

    /**
     * `id` attribute of the input field you want label to be bound to
     *
     * By default, the `<label />` will be linked to the embedded `<input />`
     * using the `for` attribute. Use this if you need to override that behavior
     **/
    htmlFor: _propTypes.default.string,

    /**
     * Renders a clickable <UIFormLabel /> alongside input with this text as content
     **/
    label: _propTypes.default.node,

    /**
     * Class name for the rendered <UIFormLabel /> component
     **/
    labelClassName: _propTypes.default.string,

    /**
     * Renders a UITooltip around the rendered <UIFormLabel /> component
     **/
    labelTooltip: _propTypes.default.node,

    /**
     * `true` indicates the field is required and will be styled accordingly
     **/
    required: _propTypes.default.bool.isRequired,

    /**
     * Instructional text to display with the the '?' icon and tooltip
     **/
    tooltip: _propTypes.default.node,

    /**
     * Placement of the tooltip
     **/
    tooltipPlacement: _propTypes.default.oneOf(_PlacementConstants.PLACEMENTS).isRequired,

    /**
     * Props passed through to the tooltip
     **/
    tooltipProps: _UIHelpIcon.default.propTypes.tooltipProps,

    /**
     * @private
     * Enables smaller sized inputs. This is not supported for all input types.
     **/
    _size: _propTypes.default.oneOf(Object.keys(sizeClasses)),

    /**
     * @private
     * Used internally to help determine open state of `labelTooltip`
     **/
    hovered: (0, _decorators.hidden)(_propTypes.default.bool),

    /**
     * Allows adjustment of automatic vertical spacing
     **/
    verticalSeparation: _propTypes.default.oneOf(['flush', 'separated'])
  },
  getDefaultProps: function getDefaultProps() {
    return {
      error: false,
      FormLabel: InlineFormLabel,
      required: false,
      tooltipPlacement: 'top',
      _size: 'medium'
    };
  },
  getInitialState: function getInitialState() {
    return {
      labelTarget: null
    };
  },
  UNSAFE_componentWillMount: function UNSAFE_componentWillMount() {
    this._fallbackId = "UIFormControl-" + (0, _underscore.uniqueId)();
    this._labelId = "UIFormControl-label-" + (0, _underscore.uniqueId)();
  },
  handleLabelClick: function handleLabelClick(evt) {
    var labeledElement = document.getElementById(evt.target.htmlFor);
    var labelableTagNames = ['BUTTON', 'INPUT', 'SELECT', 'TEXTAREA'];

    if (labeledElement && labelableTagNames.indexOf(labeledElement.tagName) === -1) {
      labeledElement.click();
    }
  },
  labelRefCallback: function labelRefCallback(ref) {
    this.setState({
      labelTarget: (0, _reactDom.findDOMNode)(ref)
    });
  },
  render: function render() {
    var _this = this;

    var _this$props = this.props,
        ariaLabel = _this$props['aria-label'],
        ariaLabelledBy = _this$props['aria-labelledby'],
        characterCount = _this$props.characterCount,
        children = _this$props.children,
        className = _this$props.className,
        description = _this$props.description,
        error = _this$props.error,
        FormLabel = _this$props.FormLabel,
        validationMessage = _this$props.validationMessage,
        help = _this$props.help,
        helpClassName = _this$props.helpClassName,
        __hovered = _this$props.hovered,
        htmlFor = _this$props.htmlFor,
        label = _this$props.label,
        labelClassName = _this$props.labelClassName,
        labelTooltip = _this$props.labelTooltip,
        required = _this$props.required,
        tooltip = _this$props.tooltip,
        tooltipPlacement = _this$props.tooltipPlacement,
        tooltipProps = _this$props.tooltipProps,
        _size = _this$props._size,
        verticalSeparation = _this$props.verticalSeparation,
        rest = (0, _objectWithoutProperties2.default)(_this$props, ["aria-label", "aria-labelledby", "characterCount", "children", "className", "description", "error", "FormLabel", "validationMessage", "help", "helpClassName", "hovered", "htmlFor", "label", "labelClassName", "labelTooltip", "required", "tooltip", "tooltipPlacement", "tooltipProps", "_size", "verticalSeparation"]);
    var labelTarget = this.state.labelTarget;

    if (!label && !ariaLabel && !ariaLabelledBy && _react.Children.only(children).type !== _UICheckbox.default) {
      _devLogger.default.warn({
        message: "UIFormControl: For better accessibility, if you're going to omit `label`, please include an `aria-label` or `aria-labelledby` property.",
        key: 'UIFormControl: label'
      });
    }

    return _react.default.createElement(_HoverProvider.default, this.props, function (hoverProviderProps) {
      return _react.default.createElement(_FieldsetContext.FieldsetContextConsumer, null, function (fieldsetContext) {
        var hovered = hoverProviderProps.hovered,
            hoverProviderRestProps = (0, _objectWithoutProperties2.default)(hoverProviderProps, ["hovered"]);
        var classes = getClassName(className, error, label, _size, verticalSeparation);
        var renderedInput = renderInput(ariaLabel, ariaLabelledBy || _this._labelId, children, description, error, help, required, validationMessage, fieldsetContext.disabled, _this._fallbackId);
        var inputId = renderedInput && renderedInput.props && renderedInput.props.id;
        return _react.default.createElement("div", Object.assign({
          className: classes
        }, rest, hoverProviderRestProps), _react.default.createElement("div", {
          className: "private-form__control-wrapper"
        }, _react.default.createElement(LabelWrapper, {
          className: "private-form__label-wrapper",
          hasLabel: label != null,
          hasHelp: help != null
        }, renderLabel(children, label, labelClassName, error, htmlFor, _this._labelId, required, tooltip, tooltipPlacement, tooltipProps, renderedInput, _this.handleLabelClick, fieldsetContext.disabled, FormLabel, _this.labelRefCallback), renderHelp(help, helpClassName, inputId)), _react.default.createElement("div", {
          className: "private-form__input-wrapper"
        }, _react.default.createElement(_UITooltip.default, {
          title: labelTooltip,
          open: hovered || undefined,
          placement: "top right",
          autoPlacement: false,
          targetAttachment: "top left",
          _insetAdjustment: -1 * parseInt(_sizes.INPUT_DEFAULT_PADDING_X, 10),
          target: labelTarget
        }, renderedInput)), _react.default.createElement("div", {
          className: "private-form__meta"
        }, _react.default.createElement("div", {
          className: "private-form__messages"
        }, renderValidation(error, validationMessage, inputId)), renderCounter(characterCount)), renderDescription(description, inputId)));
      });
    });
  }
});
var _default = UIFormControl;
exports.default = _default;
module.exports = exports.default;